// Permeability units with conversion factors to square meter (m²)
export const permeabilityUnits = [
  { id: 'square-meter', name: 'Square Meter', symbol: 'm²', plural: 'Square Meters', factor: 1 },
  { id: 'square-centimeter', name: 'Square Centimeter', symbol: 'cm²', plural: 'Square Centimeters', factor: 1e-4 },
  { id: 'square-millimeter', name: 'Square Millimeter', symbol: 'mm²', plural: 'Square Millimeters', factor: 1e-6 },
  { id: 'square-micrometer', name: 'Square Micrometer', symbol: 'μm²', plural: 'Square Micrometers', factor: 1e-12 },
  { id: 'darcy', name: 'Darcy', symbol: 'D', plural: 'Darcys', factor: 9.869233e-13 },
  { id: 'millidarcy', name: 'Millidarcy', symbol: 'mD', plural: 'Millidarcys', factor: 9.869233e-16 },
  { id: 'microdarcy', name: 'Microdarcy', symbol: 'μD', plural: 'Microdarcys', factor: 9.869233e-19 },
  { id: 'square-foot', name: 'Square Foot', symbol: 'ft²', plural: 'Square Feet', factor: 0.09290304 },
  { id: 'square-inch', name: 'Square Inch', symbol: 'in²', plural: 'Square Inches', factor: 0.00064516 },
];

export const popularPermeabilityConversions = [
  { from: 'darcy', to: 'millidarcy' },
  { from: 'millidarcy', to: 'darcy' },
  { from: 'darcy', to: 'square-meter' },
  { from: 'square-meter', to: 'darcy' },
  { from: 'millidarcy', to: 'microdarcy' },
  { from: 'square-meter', to: 'square-centimeter' },
];

export const getUnitById = (id) => permeabilityUnits.find(unit => unit.id === id);

export const convertPermeability = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert permeability units and learn the conversion formula.`;
};
